module.exports = __webpack_public_path__ + "media/images/riders/small/CATHARINE_PENDREL-5d81a686c84488ef2de472f4ef76098b.png";